import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';

import ThirdPartyAPI from '../../../api/ThirdPartyAPI';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import ApiUiController from '../../../controller/ApiUiController';
import FieldController from '../../../controller/FieldController';
import Util from '../../../util/Util';

class RealestateIndiaPreview extends React.Component {

  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.id);
    this.state = { inApiCall: true };
    this.api = { name: '', method: Const.True, access_token: '', fields: [], assigments: [] };
    this.model = reactLocalStorage.getObject(Const.Model).lead;
  }

  componentDidMount() {
    ThirdPartyAPI.get(this.id, this.onReceived, this.onFail);
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = api => {
    api.fields = JSON.parse(api.fields);
    api.assigments = JSON.parse(api.assigments);
    this.api = api;
    this.setState({ ...this.state, inApiCall: false });
  };

  render() {
    const fields = this.api.fields.map((field, i) =>
      <tr key={`field_${i}`}><td>{i + 1}</td><td>{field.key}</td><td>{field.field}</td></tr>);

    const assigments = this.api.assigments.map((assigment, i) => {
      if (!assigment.field) return null;
      let field = this.model.fields[assigment.field];
      let value = assigment.value;
      if (field !== undefined) {
        const isText = FieldController.showTextFilter(field.field_type, FieldController.Equals);
        if (!isText) {
          const options = FieldController.getOptions(field, assigment.field);
          const option = options.find(option => option.value === assigment.value);
          value = option !== undefined ? option.label : '';
        }
        field = field.label_name;
      } else if (assigment.field.includes(Const.Opt)) {
        const options = FieldController.getOptions(undefined, assigment.field);
        const option = options.find(option => option.value === assigment.value);
        value = option !== undefined ? option.label : '';
        field = assigment.field;
      } else field = assigment.field;
      return <tr key={`assign_${i}`}><td>{i + 1}</td><td>{field}</td><td>{value}</td></tr>;
    });

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <ApiUiController inApiCall={this.state.inApiCall}>

            <div className="row mb-6">
              <div className="col-md-6 pb-3"><h3>{this.api.name}</h3></div>
            </div>

            <div className="row">
              <div className="col-md-6 pb-3"><h6>CRM Field</h6></div>
              <div className="col-md-12">
                <Table className="table-th-color" bordered>
                  <thead><tr><th>Sr</th><th>API Field</th><th>CRM Field</th></tr></thead>
                  <tbody>{fields}</tbody>
                </Table>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 pb-3"><h6>Update CRM Field</h6></div>
              <div className="col-md-12">
                <Table className="table-th-color" bordered>
                  <thead><tr><th>Sr</th><th>CRM Field</th><th>Value</th></tr></thead>
                  <tbody>{assigments}</tbody>
                </Table>
              </div>
            </div>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(RealestateIndiaPreview);
